function toPositiveId(value) {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

const LEGACY_ACCOUNT_ROUTE_MAP = {
  "/resubmit-application": "/business/resubmit",
};

function getMetadata(notification) {
  return notification?.metadata && typeof notification.metadata === "object"
    ? notification.metadata
    : {};
}

export function normalizeAccountNotificationUrl(url) {
  if (!url || typeof url !== "string") return null;

  for (const [legacyPrefix, currentPrefix] of Object.entries(LEGACY_ACCOUNT_ROUTE_MAP)) {
    if (url === legacyPrefix || url.startsWith(`${legacyPrefix}/`)) {
      return url.replace(legacyPrefix, currentPrefix);
    }
  }

  return url;
}

export function resolveAccountNotificationUrl(notification, overrideUrl = null) {
  const metadata = getMetadata(notification);
  const membershipId = toPositiveId(
    metadata.membershipId ?? metadata.membership_id ?? notification?.membershipId,
  );
  const kind = String(metadata.kind || "").trim().toLowerCase();

  if (
    membershipId
    && new Set([
      "onboarding_returned_for_revision",
      "business_onboarding",
      "business_onboarding_record",
    ]).has(kind)
  ) {
    return `/account/business-onboarding/${membershipId}`;
  }

  const applicationId = toPositiveId(
    metadata.applicationId ?? metadata.application_id ?? notification?.applicationId,
  );
  const rawUrl = overrideUrl || notification?.linkUrl || notification?.link_url || null;
  const normalizedUrl = normalizeAccountNotificationUrl(rawUrl);

  if (normalizedUrl) return normalizedUrl;
  if (applicationId && kind === "business_info_requested") {
    return `/business/resubmit/${applicationId}`;
  }

  return null;
}

export function resolveBusinessNotificationUrl(notification, overrideUrl = null) {
  const metadata = getMetadata(notification);
  const membershipId = toPositiveId(
    metadata.membershipId ?? metadata.membership_id ?? notification?.membershipId,
  );
  const kind = String(metadata.kind || "").trim().toLowerCase();

  if (membershipId && kind === "invitation_accepted_business") {
    return `/business/hr/onboarding/${membershipId}`;
  }

  return overrideUrl || notification?.linkUrl || notification?.link_url || null;
}
